// Validation schema : developer's can add thier conditional vaalidations here
export default function validationObject(yup, allFields) {
  let obj = {};
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  allFields?.forEach((field) => {
    obj[field.fieldName] =
      field.fieldType === "date"
        ? yup.date().required("Select date is required")
        : field.fieldType === "email"
        ? yup
            .string()
            .required(`${field.fieldLabel} is required.`)
            .matches(emailRegex, "Invalid email format.")
            .email()
        : field.fieldType === "number"
        ? yup.number().required(`${field.fieldLabel} is required.`)
        : field.fieldType === "mobile"
        ? yup
            .string()
            .min(10, "Please enter a valid phone number")
            .max(10, "Please enter a valid phone number")
            .required(`${field.fieldLabel} is required.`)
        : field.fieldType === "startDate"
        ? yup.date().required(`${field.fieldLabel} is required.`)
        : field.fieldType === "endDate"
        ? yup
            .date()
            .required(`${field.fieldLabel} is required.`)
            .min(
              yup.ref("startDate"),
              "End date cannot be earlier than start date"
            )
        : field.fieldType === "password"
        ? yup
            .string()
            .min(5, "Password must be at least 5 characters")
            .required(`${field.fieldLabel} is required.`)
        : field.fieldType === "confirmPassword"
        ? yup
            .string()
            .oneOf([yup.ref("password"), null], "Passwords must match")
            .required(`${field.fieldLabel} is required.`)
        : yup
            .string()
            // .matches(
            //   /^[a-zA-Z\s]+$/,
            //   "Field must contain only letters and spaces"
            // )
            .max(30, "Must be 30 characters or less")
            .min(2, "Must be 2 characters required")
            .required(`${field.fieldLabel} is required.`);
  });
  return obj;
}
